import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Displays detailed power compliance information in an expandable row
 */
const PowerComplianceDetails = ({ report }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ p: 3, bgcolor: 'grey.50' }}>
      <Typography variant="h6" gutterBottom>
        {t('operationalReports.powerCompliance.title', { defaultValue: 'Power Compliance' })}
      </Typography>
      <Typography color="text.secondary">
        {t('operationalReports.powerCompliance.comingSoon', {
          defaultValue: 'Power compliance details will be displayed here.',
        })}
      </Typography>
    </Box>
  );
};

export default PowerComplianceDetails;
